import { Box, Button } from '@mui/material';
import ButtonWithLoading from '../../../../../components/ButtonWithLoading';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../translation/TranslationContext';

interface ChatFormFooterProps {
  onGoBack?: () => void;
  onSubmit?: () => void;
  isSubmitting?: boolean;
  type?: 'submit' | 'button';
  submitButtonLabel?: LangEnum;
  submitButtonIsDisabled?: boolean;
}

// TODO: ESSE COMPONENTE FICOU HORRÍVEL, TEM QUE REFATORAR, ACHO QUE TALVEZ ELE NEM SEJA NECESSÁRIO
const ChatFormFooter = ({
  type = 'button',
  onGoBack,
  onSubmit,
  isSubmitting,
  submitButtonLabel,
  submitButtonIsDisabled,
}: ChatFormFooterProps) => {
  const { translate } = useTranslation();

  return (
    <Box
      sx={{
        px: '20px',
        py: '16px',
        height: '100%',
        display: 'flex',
        gap: '12px',
        flexDirection: 'row',
        boxSizing: 'border-box',
        justifyContent: 'flex-end',
      }}
    >
      {onGoBack && (
        <Button size="small" variant="contained" onClick={onGoBack}>
          {translate(LangEnum.GLOBAL_GO_BACK)}
        </Button>
      )}
      {submitButtonLabel && (
        <ButtonWithLoading
          type={type}
          size="small"
          color="primary"
          onClick={onSubmit}
          variant="contained"
          isLoading={!!isSubmitting}
          disabled={submitButtonIsDisabled}
        >
          + {translate(submitButtonLabel)}
        </ButtonWithLoading>
      )}
    </Box>
  );
};

export default ChatFormFooter;
